<section class="search-card">
  <label class="search-label">CPF ou código do paciente</label>
  <div class="atend-row">
    <input
      type="text"
      class="atend-input"
      placeholder="Ex: 123.456.789-00 ou 1525562"
      [(ngModel)]="cdPessoaFisica"
      (keydown.enter)="buscar()" />
    <button class="btn btn--primary" (click)="buscar()" [disabled]="loading()">
      @if (loading()) { Buscando... } @else { Buscar }
    </button>
    @if (pesquisou()) {
      <button class="btn btn--ghost" (click)="limpar()">Limpar</button>
    }
  </div>
  @if (erro()) {
    <div class="search-erro">{{ erro() }}</div>
  }
</section>

@if (isAdmin() && pesquisou()) {
  <section class="emit-card">
    <h3 class="emit-card__title">Conceder cupom manualmente</h3>
    <p class="emit-card__sub">Emite um cupom direto para este paciente (emissão manual).</p>
    <input class="atend-input" type="text" placeholder="Buscar cupom por código ou nome (mín. 3 letras)..."
           [ngModel]="buscaCupom" (ngModelChange)="onBuscaCupomChange($event)" [disabled]="emitindo()" />
    @if (msgEmissao()) {
      <div class="emit-card__msg">{{ msgEmissao() }}</div>
    }
    @if (sugestoes().length > 0) {
      <ul class="emit-list">
        @for (s of sugestoes(); track s.nrSequencia) {
          <li class="emit-list__item">
            <span class="emit-list__cod">{{ s.codCupom }}</span>
            <span class="emit-list__desc">{{ s.dsCupom }}</span>
            <button class="btn btn--primary btn--sm" (click)="emitir(s)" [disabled]="emitindo()">Conceder</button>
          </li>
        }
      </ul>
    }
  </section>
}

@if (loading()) {
  <div class="state">Buscando cupons...</div>
}

@if (!loading() && pesquisou()) {

  @if (feedbackReativacao(); as fb) {
    <div class="reativacao-feedback"
         [class.reativacao-feedback--ok]="fb.tipo === 'ok'"
         [class.reativacao-feedback--erro]="fb.tipo === 'erro'">
      <span>{{ fb.texto }}</span>
      <button type="button" class="reativacao-feedback__close" (click)="feedbackReativacao.set(null)" aria-label="Fechar">&times;</button>
    </div>
  }

  @if (totalCupons() === 0 && !erro()) {
    <div class="state">Nenhum cupom encontrado para este paciente.</div>
  } @else {

    <div class="conf__result-bar">
      <span class="conf__result-count">{{ totalCupons() }} {{ totalCupons() === 1 ? 'cupom' : 'cupons' }}</span>
      <span class="conf__result-summary">
        {{ disponiveis().length }} disponivel(is) |
        {{ usados().length }} usado(s) |
        {{ expirados().length }} expirado(s)
      </span>
    </div>

    @if (disponiveis().length > 0) {
      <h3 class="conf__group-title conf__group-title--disponivel">Disponiveis ({{ disponiveis().length }})</h3>
      <div class="conf__cards">
        @for (c of disponiveis(); track c.nrSequencia) {
          <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: c }"></ng-container>
        }
      </div>
    }

    @if (usados().length > 0) {
      <h3 class="conf__group-title conf__group-title--usado">Usados ({{ usados().length }})</h3>
      <div class="conf__cards">
        @for (c of usados(); track c.nrSequencia) {
          <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: c }"></ng-container>
        }
      </div>
    }

    @if (expirados().length > 0) {
      <h3 class="conf__group-title conf__group-title--expirado">Expirados ({{ expirados().length }})</h3>
      <div class="conf__cards">
        @for (c of expirados(); track c.nrSequencia) {
          <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: c }"></ng-container>
        }
      </div>
    }

    @if (canceladosEstornados().length > 0) {
      <h3 class="conf__group-title conf__group-title--cancelado">Cancelados / Estornados ({{ canceladosEstornados().length }})</h3>
      <div class="conf__cards">
        @for (c of canceladosEstornados(); track c.nrSequencia) {
          <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: c }"></ng-container>
        }
      </div>
    }

  }
}

<ng-template #cardTpl let-c>
  <div class="ccard" [class.ccard--usado]="c.status === 'Usado'" [class.ccard--expirado]="c.status === 'Expirado'"
       [class.ccard--cancelado]="c.status === 'Cancelado' || c.status === 'Estornado'">
    <div class="ccard__head">
      <span class="ccard__code">{{ c.codCupom }}</span>
      <div class="ccard__badges">
        <span class="ccard__status ccard__status--{{ c.status | lowercase }}">{{ c.status }}</span>
        @if (c.dtReativacao) {
          <span class="ccard__reativado" [title]="'Reativado em ' + fmtDt(c.dtReativacao)">Reativado</span>
        }
        <span class="ccard__tipo">{{ tipoLabel(c.ieTipo) }}</span>
      </div>
    </div>

    <p class="ccard__desc">{{ c.dsCupom }}</p>

    <div class="ccard__discount">
      <span class="ccard__discount-value">{{ descontoLabel(c) }}</span>
      @if (c.vlTeto != null) {
        <span class="ccard__discount-cap">teto {{ fmtR(c.vlTeto) }}</span>
      }
    </div>

    <div class="ccard__details">
      <div class="ccard__detail">
        <span class="ccard__detail-label">Seq. cupom</span>
        <span class="ccard__detail-value">#{{ c.nrSeqCupomPaciente }}</span>
      </div>
      <div class="ccard__detail">
        <span class="ccard__detail-label">Emissao</span>
        <span class="ccard__detail-value">{{ c.dtEmissao ? fmtDt(c.dtEmissao) : '-' }}</span>
      </div>
      @if (c.dtExpiracao) {
        <div class="ccard__detail">
          <span class="ccard__detail-label">Expiracao</span>
          <span class="ccard__detail-value">{{ fmtDt(c.dtExpiracao) }}</span>
        </div>
      }
      @if (c.dtUso) {
        <div class="ccard__detail">
          <span class="ccard__detail-label">Atendimento</span>
          <span class="ccard__detail-value">{{ c.nrAtendimento ?? '-' }}</span>
        </div>
        <div class="ccard__detail">
          <span class="ccard__detail-label">Data uso</span>
          <span class="ccard__detail-value">{{ c.dtUso ? fmtDt(c.dtUso) : '-' }}</span>
        </div>
        @if (c.vlDescontoAplicado != null) {
          <div class="ccard__detail">
            <span class="ccard__detail-label">Desconto aplicado</span>
            <span class="ccard__detail-value">{{ fmtR(c.vlDescontoAplicado) }}</span>
          </div>
        }
      }
    </div>

    <button type="button" class="ccard__hist-toggle" (click)="alternarHistorico(c)">
      {{ historicoId() === c.nrSeqCupomPaciente ? 'Ocultar histórico' : 'Ver histórico' }}
    </button>
    @if (historicoId() === c.nrSeqCupomPaciente) {
      <div class="ccard__hist">
        @if (carregandoHistorico()) {
          <p class="ccard__hist-vazio">Carregando...</p>
        } @else if (erroHistorico()) {
          <p class="ccard__hist-vazio">{{ erroHistorico() }}</p>
        } @else if (historico().length === 0) {
          <p class="ccard__hist-vazio">Sem eventos registrados.</p>
        } @else {
          <ol class="ccard__hist-lista">
            @for (e of historicoPagina(); track $index) {
              <li class="ccard__hist-item ccard__hist-item--{{ e.tipo | lowercase }}">
                <span class="ccard__hist-quando">{{ fmtDtHora(e.dtEvento) }}</span>
                <span class="ccard__hist-oque">{{ eventoLabel(e.tipo) }}@if (e.nmUsuario) { <span> por {{ e.nmUsuario }}</span> }</span>
                <span class="ccard__hist-dados">
                  @if (e.nrInternoConta) { conta {{ e.nrInternoConta }} }
                  @if (e.nrAtendimento) { · atend. {{ e.nrAtendimento }} }
                  @if (e.nmUnidade) { · {{ e.nmUnidade }} }
                  @if (e.vlDesconto != null) { · {{ fmtR(e.vlDesconto) }} }
                  @if (e.dsDetalhe && e.tipo !== 'EMITIDO') { <span class="ccard__hist-detalhe">{{ e.dsDetalhe }}</span> }
                </span>
              </li>
            }
          </ol>
          @if (totalPaginasHistorico() > 1) {
            <div class="ccard__hist-pag">
              <button type="button" (click)="paginaHistorico.set(paginaHistorico() - 1)" [disabled]="paginaHistorico() === 1">‹ Mais recentes</button>
              <span>{{ paginaHistorico() }} / {{ totalPaginasHistorico() }}</span>
              <button type="button" (click)="paginaHistorico.set(paginaHistorico() + 1)" [disabled]="paginaHistorico() === totalPaginasHistorico()">Mais antigos ›</button>
            </div>
          }
        }
      </div>
    }

    @if (isAdmin() && c.podeReativar) {
      <div class="ccard__actions">
        @if (confirmarReativarId() === c.nrSeqCupomPaciente) {
          <span class="ccard__confirm-q">Reativar este cupom?</span>
          <button class="btn btn--sm btn--primary" (click)="confirmarReativar(c)" [disabled]="reativando()">{{ reativando() ? 'Reativando...' : 'Confirmar' }}</button>
          <button class="btn btn--sm btn--ghost" (click)="cancelarReativar()" [disabled]="reativando()">Cancelar</button>
        } @else {
          <button class="btn btn--sm btn--primary" (click)="pedirReativar(c)">Reativar</button>
        }
      </div>
    }

    @if (isAdmin() && c.nrContaRemocao) {
      <div class="ccard__actions">
        @if (confirmarRemoverId() === c.nrSeqCupomPaciente) {
          <span class="ccard__confirm-q">Remover da conta {{ c.nrContaRemocao }}? O desconto sai da conta e o cupom volta a ficar disponível.</span>
          <button class="btn btn--sm btn--primary" (click)="confirmarRemover(c)" [disabled]="removendo()">{{ removendo() ? 'Removendo...' : 'Confirmar' }}</button>
          <button class="btn btn--sm btn--ghost" (click)="cancelarRemover()" [disabled]="removendo()">Cancelar</button>
        } @else {
          <button class="btn btn--sm btn--primary" (click)="pedirRemover(c)">Remover da conta</button>
        }
      </div>
    }
  </div>
</ng-template>
